import Fuse from 'fuse.js';
import { atom, selector } from 'recoil';
import { ISearchResult } from '../lib/types';
import { adminAffiliatesAtom } from './admin';

// currently applied search
export const adminAffiliatesSearchQueryAtom = atom<string>({
   key: 'AdminAffiliatesListSearchQuery',
   default: '',
});

// searches affiliates list based on adminAffiliatesSearchQueryAtom
export const searchedAffiliatesSelector = selector({
   key: 'SearchedAffiliateList',
   get: ({ get }): ISearchResult[] => {
      const query = get(adminAffiliatesSearchQueryAtom);
      const affiliates = get(adminAffiliatesAtom);
      const searchResults: ISearchResult[] = [];

      const options = {
         includeScore: true,
         includeMatches: true,
         threshold: 0.5,
         keys: ['name'],
      };

      const fuse = new Fuse(affiliates, options);
      const results = fuse.search(query);

      for (const result of results) {
         searchResults.push({
            entity: result.item,
            key: result.matches?.[0].key,
            indices: result.matches?.[0].indices,
         });
      }

      return searchResults;
   },
});
